import {Axios} from '../axios/axios.js'

export const getDriverMapDefData = (e) => {
  return Axios({
    url:"/driver_map/get_driver_data",
    method:'put',
    data:e
  })
}
